// getters.js

export default {
    getSystemTypesList(state){
        return state.systemTypesList
    },
    getSystemTypeNameById: (state) => (id) => {
        let systemType = state.systemTypesList.find(item=>item.id === id)
        if(systemType){
            return systemType.name
        } else {
            return 'Не указано'
        }
    }
};
